module.exports = __webpack_public_path__ + "h5/img/hezishopimg5.5bf3e46b.png";